import { Fingerprint } from "lucide-react";

interface SignalChipsProps {
  signals: string[];
  staggerDelay?: number; // ms between each chip appearing, 0 = all at once
}

const SignalChips = ({ signals, staggerDelay = 0 }: SignalChipsProps) => {
  if (!signals || signals.length === 0) return null;

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex items-center gap-1.5">
        <Fingerprint className="w-3 h-3 text-muted-foreground" />
        <span className="text-[10px] uppercase tracking-[0.15em] text-muted-foreground font-mono">
          Signals Detected
        </span>
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        {signals.map((signal, i) => (
          <span
            key={i}
            className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium font-mono border"
            style={{
              background: "hsl(var(--cyan) / 0.08)",
              borderColor: "hsl(var(--cyan) / 0.25)",
              color: "hsl(var(--cyan))",
              ...(staggerDelay > 0
                ? {
                    animation: `chipReveal 0.3s ease-out ${i * staggerDelay}ms both`,
                  }
                : {}),
            }}
          >
            {signal}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SignalChips;
